import React from "react";
import { Component } from "react";
import { Row, Col, Button, Divider, Empty, Select } from "antd";
import { connect } from "react-redux";
import { UserAction } from "../../store/actions";
import { AiOutlinePlus } from "react-icons/all";
import CreditCard from "../../components/EmployeCard/creditcard";
import RadioWrapper from "../../components/RadioWrapper";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import LoaderGif from "../../assets/images/ie_loader.gif";
const { Option } = Select;

class PaymentSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 12,
        current_records: 0,
        total_pages: 0,
        total_records: 0,
      },
      radioValue: "cards",
      isOpenCard: false,
      addressPayload: { email: "", zipcode: "", phone: "", address: "" },
      addressError: {
        emailError: "",
        zipcodeError: "",
        phoneError: "",
        addressError: "",
      },
      cardPayload: {
        number: "",
        exp_year: "",
        exp_month: "",
        cvc: "",
      },
      cardErrorPayload: {
        numberError: "",
        exp_yearError: "",
        exp_monthError: "",
        cvcError: "",
      },
      accountPayload: {
        account_number: "",
        routing_number: "",
        account_holder_name: "",
        account_holder_type: "individual",
        currency: "USD",
        country: "US",
      },
      accountErrorPayload: {
        account_numberError: "",
        routing_numberError: "",
        account_holder_nameError: "",
        account_holder_typeError: "",
        currency: "USD",
        country: "US",
      },
      isOpenAch: false,
      isDisabled: false,
    };
  }
  componentDidMount() {
    const { getCards } = this.props;
    getCards(this.state.filter, this.state.radioValue);
  }

  componentDidUpdate(preProps, preState) {
    const { getCards } = this.props;
    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          total_records: this.props?.metaData?.total_records,
          current_records: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });

      if (preState.filter.page !== this.state.filter.page) {
        getCards(this.state.filter);
      }
    }
  }
  previousPage = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };

  currentPage = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  onSubmit = () => {
    const { number, cvc, exp_month, exp_year } = this.state.cardPayload;

    if (
      !number.trim().length ||
      !cvc.trim().length ||
      !exp_month.trim().length ||
      !exp_year.trim().length
    ) {
      if (!number.trim().length) {
        this.state.cardErrorPayload.numberError = "Card Number is required.";
      }
      if (!exp_month.trim().length) {
        this.state.cardErrorPayload.exp_monthError =
          "Expiry month is required.";
      }
      if (!exp_year.trim().length) {
        this.state.cardErrorPayload.exp_yearError = "Expiry year is required.";
      }
      if (!cvc.trim().length) {
        this.state.cardErrorPayload.cvcError = "Cvc is required.";
      }
      this.setState({
        cardErrorPayload: this.state.cardErrorPayload,
      });
      return;
    }
    this.setState({
      isDisabled: true,
    });
    this.props.createToken(
      this.state.cardPayload,
      () => {
        this.props.getCards(this.state.filter, this.state.radioValue);
        this.setState({
          isOpenCard: false,
          isDisabled: false,
        });
      },
      () => {
        this.setState({
          isDisabled: false,
        });
      }
    );
  };
  onSubmitBankAccount = () => {
    const { account_holder_name, account_number, routing_number } =
      this.state.accountPayload;

    if (
      !account_holder_name.trim().length ||
      !account_number.trim().length ||
      !routing_number.trim().length
    ) {
      if (!account_holder_name.trim().length) {
        this.state.accountErrorPayload.account_holder_nameError =
          "Account holder name is required.";
      }
      if (!account_number.trim().length) {
        this.state.accountErrorPayload.account_numberError =
          "Account number is required.";
      }
      if (!routing_number.trim().length) {
        this.state.accountErrorPayload.routing_numberError =
          "Routing number is required.";
      }

      this.setState({
        accountErrorPayload: this.state.accountErrorPayload,
      });
      return;
    }
    this.setState({
      isDisabled:true
    })
    this.props.createToken(
      this.state.accountPayload,
      () => {
        this.props.getCards(this.state.filter, this.state.radioValue);
        this.setState({
          isOpenAch: false,
          isDisabled: false,

        });
      },
      () => {
        this.setState({
          isDisabled: false,
        });
      }
    );
  };
  onHandleChanged = (e) => {
    this.setState({
      cardPayload: {
        ...this.state.cardPayload,
        [e.target.name]: e.target.value,
      },
      cardErrorPayload: {
        ...this.state.cardErrorPayload,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  onHandleAchChanged = (e) => {
    this.setState({
      accountPayload: {
        ...this.state.accountPayload,
        [e.target.name]: e.target.value,
      },
    });
  };
  render() {
    const { cards, getCards, metaData } = this.props;
    const {
      radioValue,
      filter,
      isOpenCard,
      addressPayload: { email, zipcode, phone, address },
      cardPayload: { number, cvc, exp_month, exp_year },
      cardErrorPayload: {
        numberError,
        cvcError,
        exp_monthError,
        exp_yearError,
      },
      accountPayload: {
        account_holder_name,
        account_holder_type,
        account_number,
        routing_number,
      },
      isOpenAch,
      accountErrorPayload: {
        account_holder_nameError,
        account_holder_typeError,
        account_numberError,
        routing_numberError,
      },
      isDisabled,
    } = this.state;
    return (
      <Row>
        <Col
          xl={24}
          lg={24}
          xs={24}
          sm={24}
          md={24}
          style={{
            minHeight: "calc(85vh - 4.8em)",
            width: "100%",
            padding: "1.1rem",
            background: "white",
            width: "100%",
            marginTop: "22px",
            boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
            border: "1px solid #f7f7f7",
          }}
        >
          <Row justify="space-between" className="st-table-header">
            <Col xl={24} lg={24} xs={24} sm={24} md={24}>
              <Row justify="space-between">
                <Col xl={12} lg={12} xs={24} sm={24} md={12}>
                  <h5 className="text-left"> Payment Methods</h5>
                </Col>

                <Col>
                  <span className="pointer-cursor">
                    <AiOutlinePlus
                      size="20"
                      onClick={() => {
                        if (radioValue === "bank_accounts") {
                          this.setState({
                            isOpenCard: false,
                            isOpenAch: true,
                            accountPayload: {
                              account_number: "",
                              routing_number: "",
                              account_holder_name: "",
                              account_holder_type: "individual",
                              currency: "USD",
                              country: "US",
                            },
                            accountErrorPayload: {
                              account_numberError: "",
                              routing_numberError: "",
                              account_holder_nameError: "",
                              account_holder_typeError: "",
                              currency: "USD",
                              country: "US",
                            },
                          });
                        } else {
                          this.setState({
                            isOpenCard: true,
                            isOpenAch: false,
                            cardErrorPayload: {
                              numberError: "",
                              exp_yearError: "",
                              exp_monthError: "",
                              cvcError: "",
                            },
                            cardPayload: {
                              number: "",
                              exp_year: "",
                              exp_month: "",
                              cvc: "",
                            },
                          });
                        }
                      }}
                    />
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="start" style={{ marginTop: "25px" }}>
            <Col span={1}>
              <RadioWrapper
                name="card"
                value={"card"}
                checked={radioValue === "cards"}
                onChange={() => {
                  this.setState({
                    radioValue: "cards",
                  });
                  getCards(filter, "cards");
                }}
              />
            </Col>
            <Col span={2}>
              <p
                className="text-left"
                style={{
                  color: "#9e9e9e",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 300,
                }}
              >
                Cards
              </p>
            </Col>
            <Col span={1}>
              <RadioWrapper
                name="card"
                value={"bank_accounts"}
                checked={radioValue === "bank_accounts"}
                onChange={() => {
                  this.setState({
                    radioValue: "bank_accounts",
                  });
                  getCards(filter, "bank_accounts");
                }}
              />
            </Col>
            <Col span={8}>
              <p
                className="text-left"
                style={{
                  color: "#9e9e9e",
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: 300,
                }}
              >
                Bank Accounts
              </p>
            </Col>
          </Row>

          <Row
            justify="start"
            gutter={[20, 30]}
            style={{
              marginTop: "15px",
              display: "flex",
              flexDirection: "row",
              height: "70%",
            }}
          >
            {!!cards.length && !this.props.isLoading ? (
              (cards || []).map((item) => {
                return (
                  <Col
                    xl={6}
                    sm={12}
                    xs={24}
                    md={8}
                    lg={8}
                    style={{ padding: "0.2rem" }}
                  >
                    <CreditCard
                      cardStyle={{
                        border: "0px solid #e0e0e0",
                        boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                        minHeight: "6rem",
                      }}
                      data={item}
                      {...this.props}
                      filter={this.state.filter}
                      dotsIcon={true}
                      radioValue={this.state.radioValue}
                      achStyling={radioValue !== "cards"}
                    />
                  </Col>
                );
              })
            ) : this.props.isLoading && !!cards.length ? (
              <Col span={24}>
                <img src={LoaderGif} height={"60"} width={"60"} />
              </Col>
            ) : (
              <Col span={24}>
                <Empty description="Nothing to show right now." />
              </Col>
            )}
            {!!cards?.length && (
              <Col
                xs={24}
                sm={24}
                md={23}
                lg={23}
                xl={23}
                style={{ display: "flex" }}
              >
                <Row
                  gutter={[5, 0]}
                  xs={24}
                  sm={24}
                  md={23}
                  lg={23}
                  xl={23}
                  justify="start"
                  align="bottom"
                >
                  <Col className="tablePagination">
                    {/* {`Displaying ${this.state.filter.current_records} of ${this.state.filter.total_records}`} */}
                    {`Displaying ${
                      this.state.filter?.page !== this.state.filter.total_pages
                        ? this.state.filter?.current_records *
                          this.state.filter?.page
                        : this.state.filter?.total_records
                    } of ${this.state.filter?.total_records}`}
                    <Button
                      type="link"
                      icon={<BsChevronLeft color="#686868" size={15} />}
                      onClick={this.previousPage}
                      // disabled={metaData?.current_page === 1}
                      disabled={
                        this.state.filter?.current_page === 1 ||
                        this.state?.filter?.page <= 1
                      }
                    />
                    {this.state?.filter.page}
                    <Button
                      type="link"
                      icon={<BsChevronRight color="#686868" size={15} />}
                      onClick={this.currentPage}
                      disabled={
                        this.state?.filter.total_records ===
                        this.state?.filter.current_records
                      }
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
        <CustomModal
          visible={isOpenCard}
          width={400}
          height={500}
          className="card-modal"
          onCancelModal={() =>
            this.setState({
              isOpenCard: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              disabled={isDisabled}
              onClick={() => {
                this.onSubmit();
              }}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5
              className="text-center st-primary"
              style={{
                color: "#47c9bf",
                fontSize: "24px",
                fontWeight: 300,
                borderBottom: "1px solid lightgrey",
                paddingBottom: "16px",
              }}
            >
              Add Card
            </h5>
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[20, 30]}>
                    <Col xl={24}>
                      <TextInput
                        className="input-font-size"
                        label="Card Number"
                        name="number"
                        onChange={this.onHandleChanged}
                        value={number}
                        required
                        maxLength={16}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {numberError && numberError}
                          </span>
                        </Col>
                      </Row>
                    </Col>{" "}
                    <Col xl={8}>
                      <TextInput
                        className="input-font-size"
                        label="Expiry Month"
                        name="exp_month"
                        onChange={this.onHandleChanged}
                        value={exp_month}
                        required
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {exp_monthError && exp_monthError}
                          </span>
                        </Col>
                      </Row>
                    </Col>{" "}
                    <Col xl={8}>
                      <TextInput
                        className="input-font-size"
                        label="Expiry Year "
                        name="exp_year"
                        onChange={this.onHandleChanged}
                        value={exp_year}
                        required
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {exp_yearError && exp_yearError}
                          </span>
                        </Col>
                      </Row>
                    </Col>{" "}
                    <Col xl={8}>
                      <TextInput
                        className="input-font-size"
                        label="CVC"
                        name="cvc"
                        onChange={this.onHandleChanged}
                        value={cvc}
                        required
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {cvcError && cvcError}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>{" "}
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <CustomModal
          visible={isOpenAch}
          width={400}
          height={500}
          className="card-modal"
          onCancelModal={() =>
            this.setState({
              isOpenAch: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => {
                this.onSubmitBankAccount();
              }}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5
              className="text-center st-primary"
              style={{
                color: "#47c9bf",
                fontSize: "24px",
                fontWeight: 300,
              }}
            >
              Add Bank Account
            </h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row
              justify="center"
              style={{
                height: "20rem",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={22}>
                      <TextInput
                        label="Account Holder Name"
                        name="account_holder_name"
                        onChange={this.onHandleAchChanged}
                        value={account_holder_name}
                        required
                        maxLength={16}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          <span className="danger-color">
                            {account_holder_nameError &&
                              account_holder_nameError}
                          </span>
                        </Col>
                      </Row>
                    </Col>

                    <Col xl={22}>
                      <TextInput
                        label="Account Number"
                        name="account_number"
                        onChange={this.onHandleAchChanged}
                        value={account_number}
                        required
                        maxLength={16}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {account_numberError && account_numberError}
                          </span>
                        </Col>
                      </Row>
                    </Col>

                    <Col xl={22}>
                      <TextInput
                        label="Routing Number"
                        name="routing_number"
                        onChange={this.onHandleAchChanged}
                        value={routing_number}
                        required
                        maxLength={9}
                      />
                      <Row>
                        <Col
                          span={24}
                          className="text-right"
                          style={{ marginTop: "10px" }}
                        >
                          {" "}
                          <span className="danger-color">
                            {routing_numberError && routing_numberError}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={22} className="select-categories">
                      <label className="st-primary">Country</label>
                      <Select
                        name="country"
                        defaultValue={"US"}
                        disabled={true}
                      >
                        <Option className="ant-select-selector ant-select-arrow ">
                          US
                        </Option>
                      </Select>
                    </Col>
                    <Col xl={22} className="select-categories">
                      <label className="st-primary">Currency</label>

                      <Select
                        name="currency"
                        defaultValue={"USD"}
                        disabled={true}
                      >
                        <Option className="ant-select-selector ant-select-arrow ">
                          USD
                        </Option>
                      </Select>
                    </Col>

                    <Col xl={22} className="select-categories">
                      <label className="st-primary">Account holder type</label>

                      <Select
                        name="account_holder_type"
                        defaultValue={"Individual"}
                        onChange={(e) => {
                          console.log("eventt==>", e);
                          this.setState({
                            accountPayload: {
                              ...this.state.accountPayload,
                              account_holder_type: e,
                            },
                          });
                        }}
                      >
                        <Option value={"individual"}>Individual</Option>
                        <Option value={"company"}>Company</Option>
                      </Select>
                    </Col>
                    {/* <Col xl={8}>
                      <TextInput
                        label="Expiry Month"
                        name="exp_month"
                        onChange={this.onHandleChanged}
                        value={exp_month}
                        required
                      />
                      <Row>
                        <Col span={24} className="text-right">
                          {" "}
                          <span className="danger-color">
                            {exp_monthError && exp_monthError}
                          </span>
                        </Col>
                      </Row>
                    </Col>{" "}
                    <Col xl={8}>
                      <TextInput
                        label="Expiry Year "
                        name="exp_year"
                        onChange={this.onHandleChanged}
                        value={exp_year}
                        required
                      />
                      <Row>
                        <Col span={24} className="text-right">
                          {" "}
                          <span className="danger-color">
                            {exp_yearError && exp_yearError}
                          </span>
                        </Col>
                      </Row>
                    </Col>{" "}
                    <Col xl={8}>
                      <TextInput
                        label="CVC"
                        name="cvc"
                        onChange={this.onHandleChanged}
                        value={cvc}
                        required
                      />
                      <Row>
                        <Col span={24} className="text-right">
                          {" "}
                          <span className="danger-color">
                            {cvcError && cvcError}
                          </span>
                        </Col>
                      </Row>
                    </Col> */}
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Row>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    cards: store.UserReducer.cards,
    metaData: store.UserReducer.metaData,
    isLoading: store.UserReducer.isLoading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCards: (params, route) =>
      dispatch(UserAction.getCardsReq(params, route)),
    createToken: (payload, cb, callback) =>
      dispatch(UserAction.createTokenReq(payload, cb, callback)),
    verifyBankAccount: (payload, bankId, cb) =>
      dispatch(UserAction.verifyBankAccountReq(payload, bankId, cb)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSettings);
